module.exports = __webpack_public_path__ + "static/media/9_angel_dong.15446e51.png";